"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerDataMaskT = exports.TrackerDataMask = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * A mask of the different components in `TrackerComponent`
 */
class TrackerDataMask {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackerDataMask(bb, obj) {
        return (obj || new TrackerDataMask()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackerDataMask(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackerDataMask()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    info() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rotation() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    position() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rawAngularVelocity() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rawAcceleration() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    temp() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    linearAcceleration() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rotationReferenceAdjusted() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rotationIdentityAdjusted() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    tps() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rawMagneticVector() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    stayAligned() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startTrackerDataMask(builder) {
        builder.startObject(13);
    }
    static addInfo(builder, info) {
        builder.addFieldInt8(0, +info, +false);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(1, +status, +false);
    }
    static addRotation(builder, rotation) {
        builder.addFieldInt8(2, +rotation, +false);
    }
    static addPosition(builder, position) {
        builder.addFieldInt8(3, +position, +false);
    }
    static addRawAngularVelocity(builder, rawAngularVelocity) {
        builder.addFieldInt8(4, +rawAngularVelocity, +false);
    }
    static addRawAcceleration(builder, rawAcceleration) {
        builder.addFieldInt8(5, +rawAcceleration, +false);
    }
    static addTemp(builder, temp) {
        builder.addFieldInt8(6, +temp, +false);
    }
    static addLinearAcceleration(builder, linearAcceleration) {
        builder.addFieldInt8(7, +linearAcceleration, +false);
    }
    static addRotationReferenceAdjusted(builder, rotationReferenceAdjusted) {
        builder.addFieldInt8(8, +rotationReferenceAdjusted, +false);
    }
    static addRotationIdentityAdjusted(builder, rotationIdentityAdjusted) {
        builder.addFieldInt8(9, +rotationIdentityAdjusted, +false);
    }
    static addTps(builder, tps) {
        builder.addFieldInt8(10, +tps, +false);
    }
    static addRawMagneticVector(builder, rawMagneticVector) {
        builder.addFieldInt8(11, +rawMagneticVector, +false);
    }
    static addStayAligned(builder, stayAligned) {
        builder.addFieldInt8(12, +stayAligned, +false);
    }
    static endTrackerDataMask(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackerDataMask(builder, info, status, rotation, position, rawAngularVelocity, rawAcceleration, temp, linearAcceleration, rotationReferenceAdjusted, rotationIdentityAdjusted, tps, rawMagneticVector, stayAligned) {
        TrackerDataMask.startTrackerDataMask(builder);
        TrackerDataMask.addInfo(builder, info);
        TrackerDataMask.addStatus(builder, status);
        TrackerDataMask.addRotation(builder, rotation);
        TrackerDataMask.addPosition(builder, position);
        TrackerDataMask.addRawAngularVelocity(builder, rawAngularVelocity);
        TrackerDataMask.addRawAcceleration(builder, rawAcceleration);
        TrackerDataMask.addTemp(builder, temp);
        TrackerDataMask.addLinearAcceleration(builder, linearAcceleration);
        TrackerDataMask.addRotationReferenceAdjusted(builder, rotationReferenceAdjusted);
        TrackerDataMask.addRotationIdentityAdjusted(builder, rotationIdentityAdjusted);
        TrackerDataMask.addTps(builder, tps);
        TrackerDataMask.addRawMagneticVector(builder, rawMagneticVector);
        TrackerDataMask.addStayAligned(builder, stayAligned);
        return TrackerDataMask.endTrackerDataMask(builder);
    }
    unpack() {
        return new TrackerDataMaskT(this.info(), this.status(), this.rotation(), this.position(), this.rawAngularVelocity(), this.rawAcceleration(), this.temp(), this.linearAcceleration(), this.rotationReferenceAdjusted(), this.rotationIdentityAdjusted(), this.tps(), this.rawMagneticVector(), this.stayAligned());
    }
    unpackTo(_o) {
        _o.info = this.info();
        _o.status = this.status();
        _o.rotation = this.rotation();
        _o.position = this.position();
        _o.rawAngularVelocity = this.rawAngularVelocity();
        _o.rawAcceleration = this.rawAcceleration();
        _o.temp = this.temp();
        _o.linearAcceleration = this.linearAcceleration();
        _o.rotationReferenceAdjusted = this.rotationReferenceAdjusted();
        _o.rotationIdentityAdjusted = this.rotationIdentityAdjusted();
        _o.tps = this.tps();
        _o.rawMagneticVector = this.rawMagneticVector();
        _o.stayAligned = this.stayAligned();
    }
}
exports.TrackerDataMask = TrackerDataMask;
class TrackerDataMaskT {
    constructor(info = false, status = false, rotation = false, position = false, rawAngularVelocity = false, rawAcceleration = false, temp = false, linearAcceleration = false, rotationReferenceAdjusted = false, rotationIdentityAdjusted = false, tps = false, rawMagneticVector = false, stayAligned = false) {
        this.info = info;
        this.status = status;
        this.rotation = rotation;
        this.position = position;
        this.rawAngularVelocity = rawAngularVelocity;
        this.rawAcceleration = rawAcceleration;
        this.temp = temp;
        this.linearAcceleration = linearAcceleration;
        this.rotationReferenceAdjusted = rotationReferenceAdjusted;
        this.rotationIdentityAdjusted = rotationIdentityAdjusted;
        this.tps = tps;
        this.rawMagneticVector = rawMagneticVector;
        this.stayAligned = stayAligned;
    }
    pack(builder) {
        return TrackerDataMask.createTrackerDataMask(builder, this.info, this.status, this.rotation, this.position, this.rawAngularVelocity, this.rawAcceleration, this.temp, this.linearAcceleration, this.rotationReferenceAdjusted, this.rotationIdentityAdjusted, this.tps, this.rawMagneticVector, this.stayAligned);
    }
}
exports.TrackerDataMaskT = TrackerDataMaskT;
